import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67e73028"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skus" }
const _hoisted_2 = { class: "sku_header" }
const _hoisted_3 = { class: "imgs" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "scroll-bar" }
const _hoisted_9 = { class: "stepper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Quantity", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "dialog" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " We will notify you the arrival of this item via message and app notification. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Waybill Would you want to add it to wishlist?.", -1))
const _hoisted_15 = { class: "butns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpecList = _resolveComponent("SpecList")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_action_bar_button = _resolveComponent("van-action-bar-button")!
  const _component_van_action_bar = _resolveComponent("van-action-bar")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_popup, {
      show: $setup.showModal,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.showModal) = $event)),
      position: "bottom",
      onClickOverlay: $setup.close,
      style: { height: '90%' },
      closeable: "",
      "close-icon": "close"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.webpFilters($setup.larger),
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString($props.seckill?$props.seckill.thousands(): parseInt($props.goods.promotion_price).thousands()), 1),
              ($props.goods.storage>0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "in stock"))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, "Sold Out"))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.goods.spec_list, (item, sepc_list_key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.spec_id
              }, [
                _createVNode(_component_SpecList, _mergeProps({ item: item }, _ctx.$attrs, {
                  good: $props.goods,
                  sepc_list_key: sepc_list_key,
                  onPitch_image: $setup.pitch_image
                }), null, 16, ["item", "good", "sepc_list_key", "onPitch_image"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_van_stepper, {
                modelValue: $setup.stepperValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.stepperValue) = $event)),
                integer: "",
                disabled: $props.goods.storage == 0 ,
                max: parseInt($props.seckill)!= parseInt($props.goods.promotion_price) ?1: $props.goods.storage 
              }, null, 8, ["modelValue", "disabled", "max"])
            ])
          ]),
          ($props.variation)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                type: "primary",
                class: "btns",
                color:  $props.goods.storage > 0 ? '#f76900' : $setup.notify_status == false ? '#44BB63' : '#DFDFDF' ,
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.notifyFn()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.goods.storage > 0
              ? "OK"
              : $setup.notify_status == false
              ? "Notify me of arrival"
              : "Cancel Arrival Notification"), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : (!$props.seckill_btns  )
              ? (_openBlock(), _createBlock(_component_van_button, {
                  key: 1,
                  type: "primary",
                  class: "btns",
                  color:  $props.goods.storage > 0 ? '#f76900' : $setup.notify_status == false ? '#44BB63' : '#DFDFDF' ,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.placeOrder()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.goods.storage > 0
              ? "OK"
              : $setup.notify_status == false
              ? "Notify me of arrival"
              : "Cancel Arrival Notification"), 1)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_van_action_bar, {
                    class: _normalizeClass([ $props.goods.storage > 0 ? "" :$setup.notify_status == false ? "van-action-color" : "van-action-gray"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_action_bar_button, {
                        type: "warning",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($props.goods.storage > 0 ?$setup.notifyFn() :null)),
                        text: "Add To Cart"
                      }),
                      _createVNode(_component_van_action_bar_button, {
                        type: "danger",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($props.goods.storage > 0 ? $setup.placeOrder() : $setup.notifyFn())),
                        text: $props.goods.storage > 0
              ? "Buy Now"
              : $setup.notify_status == false
              ? "Notify me of arrival"
              : "Cancel Arrival Notification"
                      }, null, 8, ["text"])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]))
        ])
      ]),
      _: 1
    }, 8, ["show", "onClickOverlay"]),
    _createVNode(_Transition, { name: "van-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_icon, {
            name: "checked",
            size: "36",
            color: "#44bb63"
          }),
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h2", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.collect_fn('no')))
            }, "No"),
            _createElementVNode("h2", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.collect_fn('yes')))
            }, "Yes")
          ])
        ], 512), [
          [_vShow, $setup.visible]
        ])
      ]),
      _: 1
    })
  ]))
}